// react-lottie ships CommonJS (its dist sets `__esModule` and `exports.default`).
// Vite 8 changed CJS default-import interop, so `import Lottie from "react-lottie"`
// can resolve to the module namespace object instead of the component, crashing
// render with React error #130 ("element type is invalid ... got: object").
// Normalise the interop in one place so every call site imports a real component.
// @ts-expect-error react-lottie ships no type declarations (was 3x TS7016 at the call sites)
import LottieImport from "react-lottie";

// react-lottie ships no types (LottieImport is `any`), so the interop result
// stays `any` here — matching the original call-site typing.
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const Lottie = (LottieImport as { default?: unknown }).default ?? LottieImport;

export default Lottie;
